// Utility to generate invoice PDF filename consistently for download and email
export function getInvoiceFileName(row) {
  const client = (row?.client_name || 'client').replace(/[^a-z0-9]/gi, '_');
  const project = (row?.c2c_invoice_contract_name || 'project').replace(/[^a-z0-9]/gi, '_');
  const invoice = (row?.c2c_invoice_id || 'invoice').toString().replace(/[^a-z0-9]/gi, '_');
  return `${client}_${project}_${invoice}.pdf`;
}
